/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsIdChampionPoolsQueryResponse,
  GetTournamentsIdChampionPoolsPathParams,
} from "../types/GetTournamentsIdChampionPools.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsIdChampionPoolsQueryKey = (
  id: GetTournamentsIdChampionPoolsPathParams["id"] | undefined,
) => [{ url: "/tournaments/:id/champion-pools", params: { id: id } }] as const;

export type GetTournamentsIdChampionPoolsQueryKey = ReturnType<
  typeof getTournamentsIdChampionPoolsQueryKey
>;

/**
 * @summary KAN-1676: сводка опубликованных пулов RandomDraft по матчам турнира.
 * Нужна сетке и спискам, чтобы бейдж рисовался одним запросом на страницу.
 * {@link /tournaments/:id/champion-pools}
 */
export async function getTournamentsIdChampionPools(
  id: GetTournamentsIdChampionPoolsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsIdChampionPoolsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/tournaments/${id}/champion-pools`,
    ...requestConfig,
  });
  return res;
}

export function getTournamentsIdChampionPoolsQueryOptions(
  id: GetTournamentsIdChampionPoolsPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTournamentsIdChampionPoolsQueryKey(id);
  return queryOptions<
    ResponseConfig<GetTournamentsIdChampionPoolsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetTournamentsIdChampionPoolsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournamentsIdChampionPools(id!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary KAN-1676: сводка опубликованных пулов RandomDraft по матчам турнира.
 * Нужна сетке и спискам, чтобы бейдж рисовался одним запросом на страницу.
 * {@link /tournaments/:id/champion-pools}
 */
export function useGetTournamentsIdChampionPools<
  TData = ResponseConfig<GetTournamentsIdChampionPoolsQueryResponse>,
  TQueryData = ResponseConfig<GetTournamentsIdChampionPoolsQueryResponse>,
  TQueryKey extends QueryKey = GetTournamentsIdChampionPoolsQueryKey,
>(
  id: GetTournamentsIdChampionPoolsPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsIdChampionPoolsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getTournamentsIdChampionPoolsQueryKey(id);

  const query = useQuery(
    {
      ...getTournamentsIdChampionPoolsQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
